import Util, { FOO, BAR } from "./util";

console.log(`~~ ${Util} ~~ ${FOO} ~~ ${BAR} ~~`);
